import { observable, action, computed } from 'mobx'
import { CommunicateCenter } from '@services/api'
import { ITopicItem } from '@services/api/CommunicateCenter/interface'

export interface ITopic {
  topicId: string // 当前圈子id
  topicDetail: ITopicItem
  changeTopicId: (topicId: string) => void // 更新当前topicId
  manageTopicIdList: string[] // 当前用户作为圈主可以管理的圈子ID列表，用于用户端的一些界面按钮隐藏、展示
  getManageTopicIdList: () => void // 获取 当前用户作为圈主可以管理的圈子ID列表
  isTopicManager: boolean
}

class Topic implements ITopic {
  @observable public topicId = ''
  @observable public manageTopicIdList = [] as string[]
  @observable public topicDetail = {} as ITopicItem
  @action
  public changeTopicId = (topicId: string) => {
    this.topicId = topicId
  }
  @action public getManageTopicIdList = async () => {
    const res: any = await CommunicateCenter.getManageTopicIdList()
    const { body } = res
    this.manageTopicIdList = body
    // this.manageTopicIdList = ['11', '12']
  }

  // 计算属性
  @computed public get isTopicManager() {
    return this.manageTopicIdList.includes(this.topicId)
  }
}

export default new Topic()
